import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import React from "react";

interface Props {
  // One panel per entry, each with the given number of rows
  rowCounts: number[]
}

export const SectionTemplateLoadingSkeleton = ({ rowCounts }: Props) =>
  <SectionPanel.Section>
    {rowCounts.map((rowCount, panelIndex) =>
      <SectionPanel.Panel
        key={panelIndex}
        header={panelIndex === 0 ? null : <div className="section-template-skeleton-bar title" />}
      >
        <div className="main-section-template-grid">
          {Array.from({ length: rowCount }).map((_, rowIndex) => <React.Fragment key={rowIndex}>
            <div className="main-section-template-fields-padding">
              <div className="section-template-skeleton-bar label" />
            </div>
            <div className="main-section-template-fields-padding">
              <div className="section-template-skeleton-bar value" />
            </div>
          </React.Fragment>)}
        </div>
      </SectionPanel.Panel>
    )}
  </SectionPanel.Section>;
